module.exports = __webpack_public_path__ + "img/titulo_app.fbb75d62.png";